<mat-toolbar color="primary">
    <mat-toolbar-row>
        <span>Assinatura Eletrônica</span>
    </mat-toolbar-row>
</mat-toolbar>

<main class="container">
    <router-outlet></router-outlet>
</main>

<footer style="background-color: rgb(255, 255, 255);">
    Todos os direitos reservados.
    <span style="float: right; margin-right: 10px;">Version 1.0</span>
</footer>
